import { createClient } from "next-sanity";

export const client = createClient({
  projectId: "ojrlcpom",
  dataset: "production",
  apiVersion: "2024-01-01",
  useCdn: false,
});

export default client;